import angular from 'angular';

angular.module('cloudX').directive('cxPercentage', function() {
  return {
    restrict: 'A',
    require: ['ngModel'],
    link: function(scope, element, attr, ctrls) {
      var ngModelController = ctrls[0];
      ngModelController.$parsers.push(function(viewValue) {
        if (viewValue === null) return null;
        return (viewValue / 100.0).round(10);
      });

      ngModelController.$formatters.push(function(modelValue) {
        if (modelValue === null) return null;
        return (modelValue * 100.0).round(10); //TFS #10887
      });

      //They broke the validation on number inputs: https://docs.angularjs.org/guide/migration#-input-number-
      const maxValidator = ngModelController.$validators.max;
      if (maxValidator) {
        ngModelController.$validators.max = function(modelValue, viewValue) {
          return maxValidator(modelValue, modelValue);
        };
      }

      const minValidator = ngModelController.$validators.min;
      if (minValidator) {
        ngModelController.$validators.min = function(modelValue, viewValue) {
          return minValidator(modelValue, modelValue);
        };
      }
    },
    priority: 1,
  };
});
